import { ProtectedEntitiesViewTypes } from '../childGroupsGrid/types';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';

export class AssignPolicyHelper {
  public static getProtectedEntitiesViewTypes(targets: Array<ProtectedEntity>): ProtectedEntitiesViewTypes {
    const typesToCheck = [
      Constants.ProtectedEntities.EPS.ROOT,
      Constants.ProtectedEntities.EPS.ACTIVE_DIRECTORY,
      Constants.ProtectedEntities.EPS.CUSTOM_GROUPS,
      Constants.ProtectedEntities.EPS.TYPE_EXCLUDED_FOLDER,
      Constants.ProtectedEntities.EPS.TYPE_AD_COMPUTER_GROUP,
      Constants.ProtectedEntities.EPS.TYPE_CUSTOM_GROUP,
      Constants.ProtectedEntities.EPS.TYPE_AWS_GROUP,
      Constants.ProtectedEntities.EPS.TYPE_AWS_ACCOUNT,
      Constants.ProtectedEntities.EPS.TYPE_AWS_REGION,
      Constants.ProtectedEntities.EPS.TYPE_AWS_AZ,
      Constants.ProtectedEntities.EPS.TYPE_AWS_INSTANCE,
      Constants.ProtectedEntities.EPS.TERMINATED_INSTANCES_GROUP,
      Constants.ProtectedEntities.CONTAINERS.TYPE_COLLECTION,
      Constants.ProtectedEntities.CONTAINERS.TYPE_CUSTOM_GROUPS,
      Constants.ProtectedEntities.CONTAINERS.TYPE_FOLDER,
      Constants.ProtectedEntities.CONTAINERS.TYPE_HOST,
    ];

    const result: ProtectedEntitiesViewTypes = {
      [Constants.Companies.viewType.COMPANIES_VIEW]: [],
      [Constants.ProtectedEntities.EPS.viewType.EPS_TREE_VIEW]: [],
    };

    for (const target of targets) {
      if (typesToCheck.includes(target.type)) {
        result[Constants.ProtectedEntities.EPS.viewType.EPS_TREE_VIEW].push(target._id);
      } else {
        result[Constants.Companies.viewType.COMPANIES_VIEW].push(target._id);
      }
    }

    if (result[Constants.Companies.viewType.COMPANIES_VIEW].length === 0) {
      delete result[Constants.Companies.viewType.COMPANIES_VIEW];
    }

    if (result[Constants.ProtectedEntities.EPS.viewType.EPS_TREE_VIEW].length === 0) {
      delete result[Constants.ProtectedEntities.EPS.viewType.EPS_TREE_VIEW];
    }

    return result;
  }
}
